function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.54902%,78.039216%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 24 32.398438 C 22.710938 32.398438 21.671875 33.441406 21.671875 34.726562 C 21.671875 36.011719 22.710938 37.054688 24 37.054688 C 25.285156 37 26.285156 35.914062 26.226562 34.628906 C 26.175781 33.417969 25.207031 32.449219 24 32.398438 Z M 24 32.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.54902%,78.039216%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 45.570312 32.601562 L 30.984375 7.339844 C 28.78125 3.484375 23.867188 2.148438 20.015625 4.351562 C 18.769531 5.0625 17.742188 6.09375 17.027344 7.339844 L 2.421875 32.621094 C 0.199219 36.484375 1.527344 41.414062 5.390625 43.636719 C 6.613281 44.34375 8 44.714844 9.410156 44.714844 L 38.546875 44.714844 C 41.445312 44.722656 44.125 43.171875 45.554688 40.652344 C 47.019531 38.167969 47.023438 35.089844 45.570312 32.601562 Z M 42.386719 38.824219 C 41.601562 40.210938 40.128906 41.058594 38.535156 41.054688 L 9.398438 41.054688 C 7.832031 41.066406 6.378906 40.234375 5.597656 38.875 C 4.796875 37.5 4.796875 35.804688 5.597656 34.433594 L 20.199219 9.144531 C 21.398438 7.039062 24.078125 6.308594 26.183594 7.511719 C 26.863281 7.898438 27.429688 8.464844 27.816406 9.144531 L 42.414062 34.429688 C 43.203125 35.789062 43.1875 37.472656 42.386719 38.824219 Z M 42.386719 38.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.54902%,78.039216%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 23.421875 16.050781 C 22.308594 16.382812 21.566406 17.429688 21.621094 18.589844 C 21.679688 19.324219 21.726562 20.0625 21.78125 20.808594 C 21.9375 23.609375 22.097656 26.359375 22.253906 29.160156 C 22.289062 30.09375 23.066406 30.820312 23.996094 30.800781 C 24.941406 30.804688 25.714844 30.050781 25.738281 29.109375 C 25.738281 28.527344 25.738281 28 25.796875 27.410156 C 25.898438 25.613281 26.007812 23.816406 26.113281 22.015625 C 26.171875 20.851562 26.269531 19.6875 26.324219 18.523438 C 26.335938 18.125 26.261719 17.730469 26.113281 17.359375 C 25.648438 16.328125 24.519531 15.777344 23.421875 16.050781 Z M 23.421875 16.050781 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0cfc6b599835cfe09a28b75e6f6a6f80.svg";
export { ForwardRef as ReactComponent };